import { StyleSheet } from 'react-native';
import { WARMUP_COLORS } from '../../../src/quiz/constants/warmup.constants';

export const footballerQuizViewStyles = StyleSheet.create({
  content: { flex: 1, paddingHorizontal: 14, paddingTop: 6 },
  centered: { flex: 1, alignItems: 'center', justifyContent: 'center', gap: 14, padding: 24 },
  message: { color: WARMUP_COLORS.textDim, fontSize: 14, fontWeight: '500', textAlign: 'center' },
  retryButton: { backgroundColor: WARMUP_COLORS.purple, borderRadius: 12, paddingVertical: 12, paddingHorizontal: 28 },
  retryText: { color: WARMUP_COLORS.textOnBright, fontSize: 15, fontWeight: '800' },
  pressed: { opacity: 0.9 },
});
